import { jsx as _jsx } from "react/jsx-runtime";
import cx from "classnames";
import React from "react";
import styles from "./carousel-controls.module.css";
var CarouselControls = function(param) {
    var children = param.children, customClassNames = param.customClassNames;
    return /*#__PURE__*/ _jsx("div", {
        className: cx(styles.wrapper, customClassNames),
        children: children
    });
};
export default CarouselControls;
